// 1. Create a context (new file UserProfileContext.js)
import { createContext, useContext, useState } from 'react';

const UserProfileContext = createContext();

export const UserProfileProvider = ({ children }) => {
  const [fsUserProfile, setFsUserProfile] = useState(null);
  
  return (
    <UserProfileContext.Provider value={{ fsUserProfile, setFsUserProfile }}>
      {children}
    </UserProfileContext.Provider>
  );
};

export const useUserProfile = () => {
  return useContext(UserProfileContext);
};